module.exports = __webpack_public_path__ + "img/youshi9.b0eef387.png";